import { React, Fragment, useState, useEffect, useRef, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Redirect, useHistory } from "react-router-dom"
import { Grid, Typography, makeStyles } from "@material-ui/core"
import moment from "moment"
//import { makeStyles } from "@material-ui/core/styles"
import uuid from "react-uuid"
import Header from "../../components/Header"
import SearchBuild from "../../components/build/SearchBuild"
import FiltersBuild from "../../components/build/FiltersBuild"
import ConceptsList from "../../components/build/conceptTermList/ConceptsList"
import ElementsList from "../../components/build/ElementsList"
import TagsCloud from "../../components/build/TagsCloud"
// eslint-disable-next-line
import { showAlertAction, hideAlertAction } from "../../actions/alertActions"
import {
	updateBuildHighlight,
	updateBuildSavedTags,
	updateBuildSavedTagsExclude,
	updateSearchSavedTagsExclude,
} from "../../actions/highlightActions"
import {
	searchForTopicAPI,
	setCurrentFilter,
	getSavedBuildConceptsOnAPI,
	requestSavedBuildConcepts,
	setCurrentUUID,
	loadDocumentsOfConcept,
	setRequestDocuments,
	setSearchingDocs,
	loadDocumentsOfConceptWithDocs,
	saveConceptOnNewAPI,
	loadDocumentsOfConceptWithDocsClear,
	setSelectedBuildConcept,
	saveConceptClear,
	resetPsearchApiCall,
	setSearchTerms,
} from "../../actions/buildconceptActions"
import FiltersElementsBuild from "../../components/build/FiltersElementsBuild"
import { newSearchSearch, setSelectedSearch } from "../../actions/searchActions"
import { setCurrentSearchAction } from "../../actions/currentSearchActions"
import axios from "axios"
import SideMenu from "../../components/menu/SideMenu"
import { sourceHelper } from "../../helpers/sourceHelper"
import { requestSources } from "../../actions/sourcesActions"
import { requestCustomTags } from "../../actions/customTagsActions"
import { KNOWLEDGE_BASES, getQueryParams, parsePayload, removeFileIdFromLocalStorage, useFilters } from "../../utils"
import WithDrawer from "../../components/common/drawer/withDrawer"
import Notification from "../../components/Notification/Notification"
import { BuildConcetsListView } from "./BuildConcetsListView"
import { getRetainFiltersSuccess } from "../../actions/infoActions"
import { getRetainFiltersList } from "../../actions/infoActions"
import { setFilterJobId, showDuplicateAction, showDuplicateActionReset } from "../../actions/filterActions"
import { BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS } from "../../types"
import { updateTaggedDateReset } from "../../actions/taggedDateActions"
import { ModalPopup } from "../../components/modal"
import FileDeleteModal from "../../components/common/FileDeleteModal"
import { reloadList, setIsFileDeleted } from "../../actions/deleteActions"

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
	},
	notification: {
		padding: theme.spacing(2, 10),
	},
	title: {
		fontSize: 16,
		fontWeight: 500,
		lineHeight: "20px",
	},
	fileDeletedModal: {
		width: 400,
	},
	btnRefresh: {
		textTransform: "initial",
	},
}))

const PageBuild = () => {
	const [t] = useTranslation("global")
	const classes = useStyles()
	/* ******************* REDUX STORE ******************* */
	// Check if user logged
	const isUserLogedInt = useSelector((state) => state.authtentication.loggedIn)
	//Redux actions
	const dispatch = useDispatch()
	const history = useHistory()
	const cargando = useSelector((state) => state.buildconcept.loading)
	const currentFilter = useSelector((state) => state.buildconcept.currentFilter)
	const alert = useSelector((state) => state.alert.alert)

	//const saveConceptFunc = (concept) => dispatch(sendSaveToAPI(concept));
	const updateFilterInState = (filter) => dispatch(setCurrentFilter(filter))

	const targetTerms = useSelector((state) => state.buildconcept.targetTerms)
	const searchTerms = useSelector((state) => state.buildconcept.searchTerms)
	const ignoreTerms = useSelector((state) => state.buildconcept.ignoreTerms)
	const includeSpecificTerms = useSelector((state) => state.buildconcept.includeSpecificTerms)
	const ignoreSpecificTerms = useSelector((state) => state.buildconcept.ignoreSpecificTerms)
	const topicResults = useSelector((state) => state.buildconcept.topicBuilderResults)
	const currentUUID = useSelector((state) => state.buildconcept.currentUUID)
	const requestLoadDocuments = useSelector((state) => state.buildconcept.request_documents_need)
	const currentSearchFilter = useSelector((state) => state.buildconcept.sourceFilter)
	const highlight_concepts = useSelector((state) => state.buildconcept.highlight_concepts)
	const highlightFilter = useSelector((state) => state.highlightFilter.build)
	const tags = useSelector((state) => state.highlightFilter.buildTags)
	const tagsExclude = useSelector((state) => state.highlightFilter.buildTagsExclude)
	const conceptDocs = useSelector((state) => state.buildconcept.concept_docs)
	const sourceApi = useSelector((state) => state.sources.docs_sources)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const selectedConcept = useSelector((state) => state.buildconcept.selectedConcept)
	const retainedFilterJobData = useSelector((state) => state.info?.retainedFilterJobData)
	const users = useSelector((state) => state.info?.usersList)
	const { isApplyTagSuccess } = useSelector((state) => state.search)
	const { showDuplicate } = useSelector((state) => state.filter)
	const isConceptSaved = useSelector((state) => state.buildconcept.isConceptSaved)
	const callPsearch = useSelector((state) => state.buildconcept.callPsearch)
	const currentSearch = useSelector((state) => state.currentSearchs.buildConcept)
	const isTaggedDateUpdated = useSelector((state) => state.taggedDateReducers?.isTaggedDateUpdated)
	const isFileDeleted = useSelector((state) => state.deleteFile.isFileDeleted)
	const shouldReloadList = useSelector((state) => state.deleteFile.shouldReloadList)
	/****************Ragnar Lodbrok****************/
	// const isConceptsTableLoading = useSelector((state) => state?.buildconcept?.loading_docs)
	// const conceptsDocCount = useSelector((state) => state?.buildconcept?.concept_docs?.count)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	//Component states
	// eslint-disable-next-line
	const [searchConcept, setSearchConcept] = useState("")
	// Filter State
	// eslint-disable-next-line
	const [filters, saveFilters] = useState([])
	// eslint-disable-next-line
	const [currentSearchText, setCurrentSearchText] = useState("")
	// Search State
	// eslint-disable-next-line
	const [resultSearch, saveResultSearch] = useState()
	// Show TermsList or ElementsList
	const [viewItemsBtn, setViewItemsBtn] = useState(window?.location?.search ? "files" : "list")

	// Filter for ElementsList .js
	const [elementsFilter, saveElementsFilter] = useState({
		coloursFilter: "",
		date: "",
	})
	// Filters button
	const [filtersButton, setFiltersButton] = useState(highlightFilter)
	// File types button
	const [filterList, setFilterList] = useState(sourceHelper.getFilter(sourceApi))
	// const [filterList,setFilterList] = useState({
	//     "doc": true,
	//     "xls": true,
	//     "ppt": true,
	//     "pdf": true,
	//     "txt": true,
	//     "email": true
	// })
	const [lastFilterList, setLastFilterList] = useState(sourceHelper.getFilter(sourceApi))

	const [requestNewDateSearch, setRequestNewDateSearch] = useState(false)
	// Show / Hide popups
	const [popups, setPopups] = useState({
		showFilters: false,
		showFiletypes: false,
		showLoadConcepts: false,
	})
	// SORT SAVED AND SHARED CONCEPTS LIST
	const [sortConcepts, setSortConcepts] = useState({
		dateSaved: "",
		alphabeticalSaved: "desc",
		dateShared: "",
		alphabeticalShared: "desc",
	})

	const [filterDate, setFilterDate] = useState()
	const [needToFilter, setNeedToFilter] = useState(false)
	const [border, setBorder] = useState(false)
	const [savedTags, setSavedTags] = useState(tags)
	const [savedTagsExclude, setSavedTagsExclude] = useState(tagsExclude)
	const [queryParams, setQueryParams] = useState({})
	const [counterDocs, setCounterDocs] = useState(conceptDocs.count)
	const [tempInputSearch, setTempInputSearch] = useState(null)
	const [requestByFilters, setRequestByFilters] = useState(false)
	const [cancelRequestToken, setCancelRequestToken] = useState({ old: null, new: null })
	const [searchBuildTags, setSearchBuildTags] = useState([])
	const [isConceptLoaded, setIsConceptLoaded] = useState(false)
	// Clear Search State
	const [clearSearch, setClearSearch] = useState("")
	const [currentSearchTermsSelected, setCurrentSearchTermsSelected] = useState({
		target_terms: [],
		ignore_terms: [],
		soft_ignore: [],
		soft_target: [],
		search_terms: [],
	})
	const [refreshCloudList, setRefreshCloudList] = useState()
	const [showColorLegend, setShowColorLegend] = useState(true)

	/****************Ragnar Lodbrok****************/

	// datagrid table states
	const [page, setPage] = useState(1)
	const [pageCount, setPageCount] = useState(10)
	const [recordsPerPage, setRecordsPerPage] = useState(10)
	const [sortModel, setSortModel] = useState([])
	const [toRetainFilters, setToRetainFilters] = useState(true)

	const conceptIdInitialState = {
		current: "",
		next: "",
	}
	const [conceptId, setConceptId] = useState(conceptIdInitialState)
	const [loadPSearchAfterPTopic, setLoadPSearchAfterPTopic] = useState(false)

	/* ******************* END REACT STATES ******************* */

	const getSkipCount = () => {
		return page === 1 ? 0 : (page - 1) * recordsPerPage
	}

	const getListViewPayload = () => {
		const params = history?.location?.pathname?.split("/")
		const positive_terms = highlight_concepts?.positive
		let negative_terms = highlight_concepts?.negative
		//We need to add as negative_terms the ignore_specificx
		negative_terms = negative_terms?.concat(ignoreSpecificTerms?.map((i) => i))
		//We need to add as negative_terms the ignore_specificx
		negative_terms = negative_terms?.concat(ignoreTerms?.map((i) => i))

		if (positive_terms?.length === 0 && negative_terms?.length === 0) {
			return false
		}

		const skip_count = getSkipCount()
		let negativeInput = ""

		if (negative_terms?.length > 0) {
			negativeInput = negative_terms
		}

		let payload = {
			//text: negativeInput?.length ? positive_terms?.filter((item) => !negativeInput?.includes(item)) : positive_terms,
			text: topicResults?.filter((term) => !searchTerms?.includes(term[1]))?.map((x) => x[1]) || [],
			//neg_text: negativeInput,
			categories: [],
			//search_terms: topicResults?.filter((term) => !searchTerms?.includes(term[1]))?.map((x) => x[1]) || [],
			suppress_content: false,
			dynamic_search: 0,
			or_flag: true,
			mode: "FILE",
			logical_or: "true",
			skip_count: skip_count,
			return_count: recordsPerPage,
			...filtersPayload,
			concept_id: conceptId?.current || selectedConcept?.id || "",
			remove_duplicates: showDuplicate,
			additional_params: {
				page_context: params?.[1],
				searchTerms,
			},
		}

		if (!selectedConcept) {
			payload = {
				...payload,
				currentSearchTermsSelected: currentSearchTermsSelected,
			}
		}

		if (!!sortModel.length) {
			const sort = { field: sortModel[0].field, ordering: sortModel[0].sort === "asc" ? 1 : -1 }
			payload["sort"] = sort
		}

		return payload
	}

	useEffect(() => {
		const payload = getQueryParams()
		dispatch(getRetainFiltersSuccess(payload))
	}, [])

	useEffect(() => {
		if (loadPSearchAfterPTopic && (highlight_concepts?.positive?.length > 0 || highlight_concepts?.negative?.length > 0)) {
			debouncedCallback()
			setLoadPSearchAfterPTopic((prev) => false)
		}
	}, [loadPSearchAfterPTopic, highlight_concepts])

	const fetchData = () => {
		// if (viewItemsBtn === "files") {
		// 	const payload = getListViewPayload()
		// 	if (payload) {
		// 		dispatch(
		// 			loadDocumentsOfConceptWithDocs({
		// 				params: payload,
		// 				jobIdToRetainData: toRetainFilters ? history?.location?.pathname?.split("/")?.[2] : null,
		// 			})
		// 		)
		// 		setToRetainFilters((prevData) => false)
		// 	}
		// }

		const payload = getListViewPayload()
		if (payload) {
			dispatch(
				loadDocumentsOfConceptWithDocs({
					params: payload,
					jobIdToRetainData: toRetainFilters ? history?.location?.pathname?.split("/")?.[2] : null,
				})
			)
			setToRetainFilters((prevData) => false)
		}
	}

	const ref = useRef(fetchData)

	useEffect(() => {
		ref.current = fetchData
	}, [
		page,
		viewItemsBtn,
		recordsPerPage,
		requestByFilters,
		requestLoadDocuments,
		targetTerms,
		ignoreTerms,
		includeSpecificTerms,
		ignoreSpecificTerms,
		filtersButton.fromDate,
		filtersButton.toDate,
		sortModel,
		conceptId,
		selectedConcept,
		currentSearchTermsSelected,
		highlight_concepts,
		showDuplicate,
	])

	const debouncedCallback = useMemo(() => {
		const func = () => {
			ref?.current?.()
		}
		return _.debounce(func, 500)
	}, [])

	const {
		filtersDom,
		filters: filtersData,
		isEmailFilter,
		handleReset,
		setFilters,
		fromHandler,
		toHandler,
		dateRangeHandler,
		fileTypesHandler,
		tagsHandler,
		commentsByHandler,
		viewHandler,
		setIsEmailFilter,
		attachmentHandler,
	} = useFilters({
		setPage,
		ref,
		fetchData,
		debouncedCallback,
		sortModel,
		setSortModel,
		toRetainFilters,
	})

	const mapDataToState = (data) => {
		const filterKeysAndMethods = {
			from: () => {
				fromHandler(data?.from?.data || [])
			},
			to: () => {
				toHandler(data?.to?.data || [])
			},
			tagged_date: () => {
				dateRangeHandler({
					startDate: data?.tagged_date?.data?.[0] ? moment(data?.tagged_date?.data?.[0]) : "",
					endDate: data?.tagged_date?.data?.[1] ? moment(data?.tagged_date?.data?.[1]) : "",
				})
			},
			source: () => {
				fileTypesHandler(data?.source?.data || [])
				setIsEmailFilter((prevData) => data?.source?.data?.[0] === "email" && data?.source?.data?.length === 1)
			},
			tags: () => {
				tagsHandler(data?.tags?.data || [])
			},
			commentator: () => {
				const names = users?.reduce((allUsers, currUser) => {
					if (data?.commentator?.data?.includes(currUser?.user_id)) {
						const tempUsers = [...allUsers, currUser?.username]
						return tempUsers
					}
					return allUsers
				}, [])
				commentsByHandler(names || [])
			},
			view_count: () => {
				viewHandler(data?.view_count?.kind)
			},
			has_attachment: () => {
				attachmentHandler(data?.has_attachment)
			},
		}
		if (data?.currentSearchTermsSelected) {
			setCurrentSearchTermsSelected((prevData) => ({ ...data?.currentSearchTermsSelected }))
		}
		if (data?.currentSearchTermsSelected?.target_terms) {
			setSearchBuildTags((prev) => data?.currentSearchTermsSelected?.target_terms)
		}

		if (_.has(data, "remove_duplicates")) {
			dispatch(showDuplicateAction({ data: data?.remove_duplicates }))
		}

		setConceptId((prevData) => ({ ...prevData, current: data?.concept_id }))
		const filterData = {}
		for (let filterKey of Object.keys(filterKeysAndMethods)) {
			if (data?.[filterKey]) {
				filterData[filterKey] = data?.[filterKey]
				filterKeysAndMethods?.[filterKey]?.()
			}
		}
		if (data?.sort) setSortModel((prevData) => [{ ...data?.sort, sort: data?.sort?.ordering === 1 ? "asc" : "desc" }])
		setFilters((prevData) => ({ ...prevData, ...filterData }))
		setTempInputSearch(data?.text)
		dispatch(setSearchTerms(data?.additional_params?.searchTerms || []))
		dispatch({
			type: BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS,
			payload: {
				positive: [...data?.text],
			},
		})
		setRecordsPerPage((prevData) => data?.return_count)
		setPage((prevData) => (data?.skip_count === 0 ? 1 : data?.skip_count / data?.return_count + 1))
	}

	useEffect(() => {
		if (!_.isEmpty(retainedFilterJobData)) {
			mapDataToState(retainedFilterJobData)
		}
	}, [retainedFilterJobData, queryParams])

	useEffect(() => {
		if (!toRetainFilters) {
			//dispatch(getRetainFiltersSuccess())
		}
	}, [toRetainFilters])

	useEffect(() => {
		if (history?.location?.state?.searchObject && Object.keys(history?.location?.state?.searchObject)?.length > 0) return
		const queryString = getQueryParams()
		if (!_.isEmpty(queryString) && viewItemsBtn === "files") {
			setQueryParams((prev) => queryString)
			setToRetainFilters((prevData) => true)
			setViewItemsBtn((prevData) => "files")
		}

		if (!_.isEmpty(queryParams) && viewItemsBtn === "files") {
			mapDataToState(queryParams)
			//dispatch(getRetainFiltersList(history?.location?.pathname?.split("/")?.[2]))
		} else {
			if (!_.isEmpty(queryString) && viewItemsBtn !== "files") {
				dispatch(setFilterJobId())
				const path = history?.location?.pathname?.split("/")
				history.push(`${path?.[0]}/${path?.[1]}`)
			} else if (!_.isEmpty(queryString) && viewItemsBtn !== "files") {
				handleReset()
			} else if (!_.isEmpty(queryString) && viewItemsBtn === "files") debouncedCallback()
			setToRetainFilters((prevState) => false)
		}
	}, [viewItemsBtn])

	useEffect(() => {
		if (history?.location?.state?.searchObject && Object.keys(history?.location?.state?.searchObject)?.length > 0) return
		//if (history?.location?.pathname?.split("/")?.[2]) {

		//const queryParams = getQueryParams()
		// if (!_.isEmpty(queryParams)) {
		// 	setToRetainFilters((prevData) => true)
		// 	setViewItemsBtn((prevData) => "files")
		// }
		return () => {
			dispatch(getRetainFiltersSuccess())
			dispatch(setSearchTerms([]))
		}
	}, [])

	// useEffect(() => {
	// 	if (!_.isEmpty(queryParams)) {
	// 		setToRetainFilters((prevData) => true)
	// 		setViewItemsBtn((prevData) => "files")
	// 	}
	// }, [queryParams])

	var filtersPayload = parsePayload(filtersData)

	/* ******************* USE-EFFECTS ******************* */
	useEffect(() => {
		if (history?.location?.state?.searchObject && Object.keys(history?.location?.state?.searchObject)?.length > 0) return
		if (viewItemsBtn === "files") {
			/* Have to change this method once we know the exact terms to send */
			//setCancelRequestToken({ old: cancelRequestToken.new, new: axios.CancelToken.source() })
			debouncedCallback()
			// eslint-disable-next-line
		}
	}, [page, recordsPerPage, sortModel])

	useEffect(() => {
		if (history?.location?.state?.searchObject && Object.keys(history?.location?.state?.searchObject)?.length > 0) return
		if (viewItemsBtn !== "files") {
			//dispatch(loadDocumentsOfConceptWithDocsClear())
			setPage(1)
		}
	}, [viewItemsBtn])

	useEffect(() => {
		if (selectedConcept) dispatch(requestSavedBuildConcepts())
	}, [selectedConcept])

	useEffect(() => {
		dispatch(updateBuildSavedTagsExclude(savedTagsExclude))
	}, [savedTagsExclude])

	useEffect(() => {
		dispatch(updateBuildSavedTags(savedTags))
	}, [savedTags])

	useEffect(() => {
		dispatch(updateBuildHighlight(filtersButton))
	}, [filtersButton])

	useEffect(() => {
		//Render on init
		// dispatch(getSavedBuildConceptsOnAPI());
		dispatch(requestSavedBuildConcepts())
		// eslint-disable-next-line

		return () => {
			dispatch(setSelectedSearch(undefined)) //on unmount Selected concept set to undefined
		}
	}, [])

	useEffect(() => {
		dispatch(requestSavedBuildConcepts())
		if (history?.location?.state?.searchObject && Object.keys(history?.location?.state?.searchObject)?.length > 0) return
		if (!window?.location?.search) setViewItemsBtn("list")
	}, [selectedBaseId])

	useEffect(() => {
		if (requestLoadDocuments) {
			//const positive_terms=[...targetTerms,...includeSpecificTerms];
			//const negative_terms=[...ignoreTerms,...ignoreSpecificTerms];
			/* Have to change this method once we know the exact terms to send */
			const positive_terms = highlight_concepts?.positive || []
			let negative_terms = highlight_concepts?.negative || []
			if (ignoreSpecificTerms.length > 0) {
				//We need to add as negative_terms the ignore_specificx
				negative_terms = negative_terms.concat(ignoreSpecificTerms.map((i) => i))
			}
			if (ignoreTerms.length > 0) {
				//We need to add as negative_terms the ignore_specificx
				negative_terms = negative_terms.concat(ignoreTerms.map((i) => i))
			}

			if (positive_terms.length > 0 || negative_terms.length > 0) {
				setCancelRequestToken({ old: cancelRequestToken.new, new: axios.CancelToken.source() })
				if (viewItemsBtn === "files") {
					debouncedCallback()
				} else {
					dispatch(loadDocumentsOfConcept(positive_terms, negative_terms, filtersObject, cancelRequestToken.new))
				}
				setRequestDocuments(false)
				setSearchingDocs(false)
			} else {
				dispatch(setRequestDocuments(false))
				dispatch(setSearchingDocs(false))
			}
		}
		/*return () => {
            if (cancelRequestToken.old!==null){
                cancelRequestToken.old.cancel("axios request cancelled");
            }
        };*/
		return
		// eslint-disable-next-line
	}, [
		requestLoadDocuments,
		targetTerms,
		ignoreTerms,
		includeSpecificTerms,
		ignoreSpecificTerms,
		filtersButton.fromDate,
		filtersButton.toDate,
	])

	useEffect(() => {
		//active filters in search
		let activeInSearch = []

		Object.keys(currentSearchFilter).forEach(function (key) {
			if (currentSearchFilter[key] === true) {
				activeInSearch.push(key)
			}
		})

		let activeInFilter = []
		Object.keys(filterList).forEach(function (key) {
			if (filterList[key] === true) {
				activeInFilter.push(key)
			}
		})

		if (tempInputSearch !== null || highlight_concepts.positive.length > 0 || highlight_concepts.negative.length > 0) {
			setRequestByFilters(true)
		}
	}, [requestNewDateSearch, filtersButton.fromDate, filtersButton.toDate])

	useEffect(() => {
		if (requestByFilters) {
			setRequestByFilters(false)
			refreshFilterTypeSearch(tempInputSearch)
			const positive_terms = highlight_concepts.positive
			let negative_terms = highlight_concepts.negative
			if (ignoreSpecificTerms.length > 0) {
				//We need to add as negative_terms the ignore_specificx
				negative_terms = negative_terms.concat(ignoreSpecificTerms.map((i) => i))
			}
			if (ignoreTerms.length > 0) {
				//We need to add as negative_terms the ignore_specificx
				negative_terms = negative_terms.concat(ignoreTerms.map((i) => i))
			}

			if (positive_terms.length > 0 || negative_terms.length > 0) {
				setCancelRequestToken({ old: cancelRequestToken.new, new: axios.CancelToken.source() })
				if (viewItemsBtn === "files") {
					debouncedCallback()
				} else {
					dispatch(loadDocumentsOfConcept(positive_terms, negative_terms, filtersObject, cancelRequestToken.new))
				}
				dispatch(setRequestDocuments(false))
				dispatch(setSearchingDocs(false))
			} else {
				dispatch(setRequestDocuments(false))
				dispatch(setSearchingDocs(false))
			}
		}
		return () => {
			if (cancelRequestToken.old !== null) {
				cancelRequestToken.old.cancel("axios request cancelled")
			}
		}
	}, [requestByFilters])

	// Add border class to input
	useEffect(() => {
		if (alert !== null) {
			setBorder(true)
		} else {
			setBorder(false)
		}
	}, [alert])

	useEffect(() => {
		// if (Object.keys(sourceApi).length === 0 && Object.keys(lastFilterList).length === 0) {
		// 	dispatch(requestSources())
		// 	dispatch(requestCustomTags())
		// }

		if (Object.keys(sourceApi).length > 0) {
			setFilterList(sourceHelper.getFilter(sourceApi))
			setLastFilterList(sourceHelper.getFilter(sourceApi))
		}
	}, [sourceApi])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		isApplyTagSuccess && debouncedCallback()
	}, [isApplyTagSuccess])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		isTaggedDateUpdated && debouncedCallback()
	}, [isTaggedDateUpdated])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		debouncedCallback()
	}, [showDuplicate])

	useEffect(() => {
		dispatch(showDuplicateActionReset())
	}, [])

	useEffect(() => {
		dispatch(updateTaggedDateReset())
	}, [isTaggedDateUpdated])

	useEffect(() => {
		if (isConceptSaved) {
			debouncedCallback()
			dispatch(saveConceptClear())
		}
	}, [isConceptSaved])

	useEffect(() => {
		if (callPsearch) {
			debouncedCallback()
			dispatch(resetPsearchApiCall())
		}
	}, [callPsearch])

	useEffect(() => {
		const payload = getQueryParams()
		dispatch(getRetainFiltersSuccess(payload))
	}, [])

	//reload the list once delete is success then update the flag
	useEffect(() => {
		if (shouldReloadList) {
			dispatch(reloadList(false))
			debouncedCallback()
		}
	}, [shouldReloadList])

	useEffect(() => {
		window.addEventListener("beforeunload", removeFileIdFromLocalStorage)

		return () => {
			window.removeEventListener("beforeunload", removeFileIdFromLocalStorage)
			removeFileIdFromLocalStorage()
		}
	}, [])

	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	// Create Filter Function
	const createFilter = (filter) => {
		saveFilters([filter])
		updateFilterInState({
			...currentFilter,
			phrase_count: filter.positiveRange,
			neg_phrase_count: filter.negativeRange,
		})
	}
	//Apply filters
	const applyFilterSource = () => {
		if (tempInputSearch !== null || highlight_concepts.positive.length > 0 || highlight_concepts.negative.length > 0) {
			setRequestByFilters(true)
		}
	}

	// Create Search Function
	const refreshFilterTypeSearch = (inputSearch) => {
		setTempInputSearch(inputSearch)
		dispatch(setRequestDocuments(true))
		dispatch(setSearchingDocs(true))
	}

	// Create Search Function
	const searchTopic = (item) => dispatch(searchForTopicAPI(item))

	const createSearch = (searchBuildTags, resetUuid = true, fullListParameters = null) => {
		setTempInputSearch(searchBuildTags)
		//dispatch(clearTerms());
		setCurrentSearchText(searchBuildTags)
		dispatch(hideAlertAction())
		saveResultSearch(searchBuildTags)
		let searchItem
		if (fullListParameters != null) {
			searchItem = {
				...fullListParameters,
				phrase_count: currentFilter.phrase_count,
				strict: true,
				neg_phrase_count: currentFilter.neg_phrase_count,
			}
		} else {
			//    searchItem={
			//     "target_terms":[],
			//     "ignore_terms":[],
			//     "soft_ignore":[],
			//     "soft_target":[],
			//     "phrase_count":currentFilter.phrase_count,
			//     "strict":false
			//     }
			setCurrentSearchTermsSelected((prevData) => ({ ...prevData, target_terms: searchBuildTags }))

			searchItem = {
				knowledgebase: KNOWLEDGE_BASES.COMBINED,
				force_init: false,
				target_terms: [],
				ignore_terms: [],
				phrase_count: currentFilter.phrase_count,
				neg_phrase_count: currentFilter.neg_phrase_count,
				strict: true,
				soft_ignore: [],
				soft_target: [],
				search_terms: [],
				location: "build concepts",
			}
		}
		//MODIFIY searchItem IN THE FUTURE TO SEARCH FULL SAVED CONCEPT
		//searchItem.target_terms.push(inputSearch.toLowerCase());
		searchItem.target_terms = searchBuildTags
		searchTopic(searchItem)
		//Create a new UUID for this search
		if (resetUuid) {
			dispatch(setCurrentUUID(null))
		}
	}

	//Save concept in API
	const saveConcept = (description, id) => {
		dispatch(hideAlertAction())
		let idNew = currentUUID === null ? uuid() : currentUUID
		const conceptToSave = {
			id: id ? id : currentUUID,
			description: description,
			doc_count: conceptDocs?.count || -1,
			visual: {
				terms: targetTerms?.length ? targetTerms : currentSearch?.text || [],
				ignore: ignoreTerms,
				soft_ignore: ignoreSpecificTerms,
				soft_target: includeSpecificTerms,
				strict: "true",
				phrase_count: currentFilter.phrase_count,
				neg_phrase_count: currentFilter.neg_phrase_count,
				search_terms: topicResults?.filter((term) => !searchTerms?.includes(term[1]))?.map((x) => x[1]) || [],
			},

			topic: {
				terms: topicResults.map((x) => x[1]),
				count: topicResults.map((x) => x[0]),
				relatedness: topicResults.map((x) => x[2]),
			},
			shared: currentFilter.share,
			creation_time: new Date().toISOString(),
		}
		dispatch(saveConceptOnNewAPI(conceptToSave))
		//saveConceptFunc(conceptToSave);
	}
	//Submit Search
	const submitSearch = (searchText, categories) => {
		//Validar y comprobar si nom hay errores

		//Hide alert
		dispatch(hideAlertAction())
		//Send to API
		//Get date filter
		let searchFilters = { datesFilter: { fromData: filtersButton.fromDate, toDate: filtersButton.toDate } }
		dispatch(newSearchSearch(searchText, filtersObject, categories, "buildconcept"))
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	const filtersObject = { ...filtersButton, ...filterList }
	let checker = (arr, target) => target.every((v) => arr.includes(v))
	/* ******************* END VARIABLES ******************* */
	try {
		document.body.style.backgroundImage = "none"
		document.body.classList.remove("newLoginPage")
	} catch (e) {}

	return (
		<Grid className={classes.root} container direction="row" data-testid="build_concepts_page">
			<Grid item xs={12} className={classes.notification}>
				<Notification />
			</Grid>
			<Grid container alignItems="center" justifyContent="space-between">
				<Grid item style={{ width: "100%" }}>
					<Grid container alignItems="center">
						<div className="container-fluid">
							<Typography variant="h1" className={classes.title}>
								{t("concept.title")}
							</Typography>
						</div>
						<SearchBuild
							createSearch={createSearch}
							saveConceptBuilder={saveConcept}
							popups={popups}
							setPopups={setPopups}
							elementsFilter={elementsFilter}
							saveElementsFilter={saveElementsFilter}
							sortConcepts={sortConcepts}
							setSortConcepts={setSortConcepts}
							filtersButton={filtersButton}
							filterList={filterList}
							border={border}
							setBorder={setBorder}
							searchBuildTags={searchBuildTags}
							setSearchBuildTags={setSearchBuildTags}
							clearSearch={clearSearch}
							setClearSearch={setClearSearch}
							setCurrentSearchTermsSelected={setCurrentSearchTermsSelected}
							isConceptLoaded={isConceptLoaded}
							setIsConceptLoaded={setIsConceptLoaded}
							toRetainFilters={toRetainFilters}
							terms={tempInputSearch}
							conceptId={conceptId}
							setConceptId={setConceptId}
							conceptIdInitialState={conceptIdInitialState}
							setPage={setPage}
							currentSearchTermsSelected={currentSearchTermsSelected}
							searchTopic={searchTopic}
							debouncedCallback={debouncedCallback}
							setLoadPSearchAfterPTopic={setLoadPSearchAfterPTopic}
							viewItemsBtn={viewItemsBtn}
							setViewItemsBtn={setViewItemsBtn}
							handleReset={handleReset}
						/>

						{/* for heatmap */}

						{viewItemsBtn === "list" ? (
							<Fragment>
								<FiltersBuild
									createFilter={createFilter}
									viewItemsBtn={viewItemsBtn}
									setViewItemsBtn={setViewItemsBtn}
									setNeedToFilter={setNeedToFilter}
									counterDocs={conceptDocs?.count || counterDocs}
									setCounterDocs={setCounterDocs}
									setCurrentSearchTermsSelected={setCurrentSearchTermsSelected}
									showColorLegend={true}
								/>
								{alert && alert.type !== "modal" ? <p className={alert.class}>{alert.msg}</p> : null}
								<ConceptsList
									currentSearchTermsSelected={currentSearchTermsSelected}
									setCurrentSearchTermsSelected={setCurrentSearchTermsSelected}
								/>
							</Fragment>
						) : null}

						{/* for list view */}
						{viewItemsBtn === "files" ? (
							<Fragment>
								<FiltersElementsBuild
									viewItemsBtn={viewItemsBtn}
									setViewItemsBtn={setViewItemsBtn}
									elementsFilter={elementsFilter}
									saveElementsFilter={saveElementsFilter}
									createFilter={createFilter}
									filtersButton={filtersButton}
									setFiltersButton={setFiltersButton}
									setFilterList={setFilterList}
									filterList={filterList}
									popups={popups}
									setPopups={setPopups}
									setRequestNewDateSearch={setRequestNewDateSearch}
									setNeedToFilter={setNeedToFilter}
									setFilterDate={setFilterDate}
									savedTags={savedTags}
									setSavedTags={setSavedTags}
									savedTagsExclude={savedTagsExclude}
									setSavedTagsExclude={setSavedTagsExclude}
									counterDocs={conceptDocs?.count || counterDocs}
									setCounterDocs={setCounterDocs}
									applyFilterSource={applyFilterSource}
								/>
								{alert && alert.type !== "modal" ? <p className={alert.class}>{alert.msg}</p> : null}
								{/* {cargando ? (
									<div className="col-12 d-flex justify-content-center mt-3 mb-3">
										<div className="d-flex align-items-center alert alert-warning">
											<strong className="loading">Loading...</strong>
											<div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
										</div>
									</div>
								) : null} */}
								{/* <ElementsList
									elementsFilter={elementsFilter}
									filtersButton={filtersButton}
									filterList={filterList}
									needToFilter={needToFilter}
									setNeedToFilter={setNeedToFilter}
									filterDate={filterDate}
								/> */}
								{
									<>
										{filtersDom}
										<BuildConcetsListView
											page={page}
											setPage={setPage}
											pageCount={pageCount}
											recordsPerPage={recordsPerPage}
											setRecordsPerPage={setRecordsPerPage}
											isEmailType={isEmailFilter}
											sortModel={sortModel}
											setSortModel={setSortModel}
										/>
									</>
								}
							</Fragment>
						) : null}

						{/* for cloud heatmap */}
						{viewItemsBtn === "cloud" ? (
							<Fragment>
								<FiltersBuild
									createFilter={createFilter}
									viewItemsBtn={viewItemsBtn}
									setViewItemsBtn={setViewItemsBtn}
									setNeedToFilter={setNeedToFilter}
									counterDocs={conceptDocs?.count || counterDocs}
									setCounterDocs={setCounterDocs}
									setCurrentSearchTermsSelected={setCurrentSearchTermsSelected}
									refreshCloudList={refreshCloudList}
									showColorLegend={false}
								/>
								{alert && alert.type !== "modal" ? <p className={alert.class}>{alert.msg}</p> : null}
								{cargando ? (
									<div className="col-12 d-flex justify-content-center mt-3 mb-3">
										<div className="d-flex align-items-center alert alert-warning">
											<strong className="loading">Loading...</strong>
											<div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
										</div>
									</div>
								) : null}
								<TagsCloud
									currentSearchTermsSelected={currentSearchTermsSelected}
									setRefreshCloudList={setRefreshCloudList}
									setShowColorLegend={setShowColorLegend}
									showColorLegend={showColorLegend}
								/>
							</Fragment>
						) : null}
					</Grid>
				</Grid>
			</Grid>
			<ModalPopup
				className={classes.fileDeletedModal}
				title={
					<Typography variant="body1" style={{ fontWeight: 500 }}>
						This file has been deleted
					</Typography>
				}
				open={isFileDeleted}
				//setOpen={() => dispatch(setIsFileDeleted(false))}
				showClose={false}
				showDivider={false}
			>
				<FileDeleteModal
					content={t("deleteFile.messageList")}
					btnText={t("deleteFile.buttonTextList")}
					navigate={() => {
						dispatch(setIsFileDeleted(false))
						debouncedCallback()
					}}
				/>
			</ModalPopup>
		</Grid>
		// 			</div>
		// 		</div>
		// 	</div>
		// </Fragment>
	)
}

export default WithDrawer(PageBuild)
